export const comments_4791870 = {"data":{"data":[],"links":{}}}